<template>
  <div class="dui-gallery-vessel">
    <div
      class="page"
      @click="addImage"
    >
      <img :src="illustratedBookIconUrl">
      <small>Please upload your images</small>
    </div>
    <div
      class="page"
      @click="addImage"
    />
  </div>
</template>

<script>
import TAB_OPTION_ILLUSTRATED_IMG from '@dui-assets/tab-option-illustrated.svg';

export default {
  data: () => ({
    illustratedBookIconUrl: TAB_OPTION_ILLUSTRATED_IMG,
  }),
  methods: {
    addImage() {
      this.$emit('add-image');
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.dui-gallery-vessel {
  display: flex;
  flex-wrap: nowrap;
  padding: $_2em $_4em $_1em $_2em;
  overflow: visible;

  @include transition((
    transform
  ));

  .page {
    background-color: getColor($white);
    box-shadow: $box-shadow-sm;
    display: inline-flex;
    flex: none;
    flex-direction: column;
    height: $gallery-page-height;
    justify-content: center;
    margin: 0 0 $_2em $_2em;
    max-width: calc(100% + #{ $_2em });
    position: relative;
    width: $gallery-page-width;

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      cursor: pointer;
    }

    small {
      color: getColor($grey, dark);
      margin: $_1em 0 0;
      text-align: center;
      text-transform: uppercase;
    }
  }
}
</style>
